import { useState, useEffect } from 'react';
import { useGetDownloadVideoURL } from '@/hooks/useGetVideoURL';
import { useResolution886Report } from '@/context/Resolution886Report';

interface Video {
	id: string;
	original_name: string;
	generated_name: string;
}

export function useGetVideoUrl(video: Video) {
	const { report } = useResolution886Report();
	const [videoUrl, setVideoUrl] = useState<string>('');

	const { data: videoUrlData } = useGetDownloadVideoURL({
		organization_id: report.organization?.id || '',
		company_id: report.company?.id || '',
		file_id: video.id,
		original_name: video.original_name
	});

	useEffect(() => {
		if (videoUrlData) {
			setVideoUrl(videoUrlData);
		}
	}, [videoUrlData]);

	return videoUrl;
}
